import { faBook, faGraduationCap, faTrophy } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import './styles.css'
import { useUserStorage } from '../../../../storage/user'
import { useCursosStorage } from '../../../../storage/cursos'

export default function PainelContent() {

    const { cursosDoEstudante } = useCursosStorage(state => state.dados)

    return (
        <div style={{ width: '100%', padding: '20px' }}>
            <h2 className='titlePainel'>Painel</h2>

            <div className='painelDiv'>

                <Cards qtn={cursosDoEstudante?.length || '0'} title='Cursos matriculados' icon={faBook} />
                {/* <Cards qtn='0' title='Cursos ativos' icon={faGraduationCap} />
                <Cards qtn='0' title='Cursos completos' icon={faTrophy} /> */}
            </div>
        </div>
    )
}

function Cards({ icon, qtn, title }) {
    return (
        <div style={{ margin: '10px', width: '250px', height: '250px', borderRadius: '10px', border: '1px solid #ddd', display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignItems: 'center' }}>
            <div style={{ width: '60px', height: '60px', background: '#3e64de1a', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '50px' }}>
                <FontAwesomeIcon color='#3e64de' icon={icon} size='2x' />
            </div>
            <h1>{qtn}</h1>
            <h3 style={{ color: '#333' }}>{title}</h3>
        </div>
    )
}




